/* ---------------------------------------------------------------------------
   Bottega d'Arte Stringa: il pop-up del gioco delle carte parla con Klaviyo.

   Nell'anteprima il modulo non mandava l'email da nessuna parte: si passava
   allo schermo "Controlla la tua email" e basta, ma nessuna email partiva.

   Qui l'indirizzo va davvero in Klaviyo, con la chiave PUBBLICA (company_id):
   e' l'unica che puo' stare in una pagina, e serve solo a iscrivere qualcuno a
   una lista. Due iscrizioni:

     Pop-up · sconto BENVENUTO10  -> fa partire l'email con il codice, subito
     Elenco e-mail                -> fa partire la serie di Benvenuto

   Lo schermo di conferma si mostra solo se Klaviyo ha risposto bene: dire
   "controlla la tua email" quando l'iscrizione e' fallita e' il modo piu'
   rapido di perdere una persona.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  var AZIENDA = "SSDMq6";
  var LISTE = ["Ucj8Vh", "VJrvkS"]; // sconto, poi elenco generale
  var REV = "2026-07-15";

  function iscrivi(lista, email) {
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + AZIENDA, {
      method: "POST",
      headers: { revision: REV, "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  properties: { origine: "pop-up gioco delle carte" },
                },
              },
            },
          },
          relationships: { list: { data: { type: "list", id: lista } } },
        },
      }),
    });
  }

  function mostraStadio(n) {
    [1, 2, 3].forEach(function (i) {
      var s = document.getElementById("promoStage" + i);
      if (s) s.hidden = i !== n;
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.id !== "promoForm") return;
    e.preventDefault();

    var campo = form.querySelector('input[type="email"]');
    var email = campo ? (campo.value || "").trim() : "";
    if (!email || email.indexOf("@") < 1) {
      if (campo) campo.reportValidity && campo.reportValidity();
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    var etichetta = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Un attimo…"; }

    // la prima iscrizione e' quella che manda il codice: se fallisce, si dice
    iscrivi(LISTE[0], email)
      .then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error("iscrizione " + r.status);
        // la seconda e' in piu': se non riesce non si blocca la persona
        return iscrivi(LISTE[1], email).catch(function () { return null; });
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = etichetta; }
        mostraStadio(3);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = etichetta; }
        var avviso = form.querySelector(".promo-errore");
        if (!avviso) {
          avviso = document.createElement("div");
          avviso.className = "promo-errore";
          form.appendChild(avviso);
        }
        avviso.textContent = "Non siamo riusciti a registrare l'indirizzo. Riprova, o scrivici.";
      });
  });
})();

/* ---------------------------------------------------------------------------
   Il pallino del 10%, e la regola che il pop-up esce una volta sola.

   Chiesto da Edoardo il 19/09/2026:

     · il pop-up esce dopo 7 secondi              (c'era gia', resta)
     · se lo chiudono, NON torna per il resto della visita
     · alla visita dopo si ricomincia da capo, pop-up compreso
     · al suo posto resta in basso a sinistra un pallino con scritto "10%",
       e cliccandolo il pop-up si riapre
     · sul pallino, in alto a sinistra, una x piccola per mandare via anche
       quello

   ⚠️ Perche' sta qui e non nelle quattro sezioni. Il pop-up e' copiato dentro
   adville-homepage, adville-prodotto, adville-collezione e adville-collezioni:
   quattro copie della stessa cosa. Una funzione scritta qui vale per tutte e
   quattro, e soprattutto **si corregge in un posto solo**. Nelle sezioni resta
   il minimo indispensabile: il magazzino giusto e un aggancio per riaprire.

   ⚠️ Il pallino non esce a chi si e' gia' iscritto: ha gia' il codice nella
   posta, riproporglielo e' solo fastidio.

   ⚠️ Una volta per VISITA, non una volta e basta. Per mezza giornata era stato
   scritto nel magazzino permanente, cioe' chiuso per sempre: sbagliato. E non
   puo' nemmeno essere «a ogni pagina», perche' su uno store ogni clic su un
   prodotto e' una pagina nuova, e vorrebbe dire richiuderlo a ogni clic: e'
   proprio la cosa che Edoardo non vuole. La durata scheda e' la visita.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  // Durata visita, la stessa del pop-up, che scrive bdsPromoClosed li' dentro.
  var CHIUSO = "bdsPromoClosed";       // ha chiuso il pop-up
  var VIAPALLINO = "bdsPromoBadgeOff"; // ha mandato via anche il pallino
  // Durata per sempre: chi si e' iscritto ha gia' il codice nella posta.
  var EMAIL = "bdsPromoEmail";

  function inVisita(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function segnaVisita(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function perSempre(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }

  function siMostra() {
    return inVisita(CHIUSO) === "1" && inVisita(VIAPALLINO) !== "1" && !perSempre(EMAIL);
  }

  var pallino = null;

  function costruisci() {
    if (pallino || document.getElementById("bdsPromoBadge")) return;

    var stile = document.createElement("style");
    stile.textContent =
      "#bdsPromoBadge{position:fixed;left:16px;bottom:16px;z-index:9997;width:58px;height:58px;" +
      "border-radius:50%;border:0;padding:0;cursor:pointer;background:#25451C;color:#FAF9F4;" +
      "font-family:'DM Sans',system-ui,sans-serif;font-size:15px;font-weight:700;letter-spacing:.01em;" +
      "box-shadow:0 8px 22px rgba(18,54,63,.34);display:grid;place-items:center;" +
      "opacity:0;transform:translateY(8px);transition:opacity .25s ease,transform .25s ease,background .15s ease}" +
      "#bdsPromoBadge.bds-su{opacity:1;transform:translateY(0)}" +
      "#bdsPromoBadge:hover{background:#182E12}" +
      /* la x sta in alto a SINISTRA del pallino, come chiesto. E' un fratello,
         non un figlio: un bottone dentro un bottone non e' HTML valido e su
         Safari il clic finisce al genitore, quindi mandando via il pallino si
         riaprirebbe il pop-up. */
      "#bdsPromoBadgeX{position:fixed;left:8px;bottom:58px;z-index:9998;width:20px;height:20px;" +
      "border-radius:50%;border:1px solid #E3DDCE;padding:0;cursor:pointer;background:#FAF9F4;color:#54666B;" +
      "font-family:'DM Sans',system-ui,sans-serif;font-size:11px;line-height:1;" +
      "box-shadow:0 2px 6px rgba(18,54,63,.22);display:grid;place-items:center;" +
      "opacity:0;transition:opacity .25s ease,color .15s ease}" +
      "#bdsPromoBadgeX.bds-su{opacity:1}" +
      "#bdsPromoBadgeX:hover{color:#12363F}" +
      "@media (prefers-reduced-motion:reduce){#bdsPromoBadge,#bdsPromoBadgeX{transition:none}}";
    document.head.appendChild(stile);

    pallino = document.createElement("button");
    pallino.id = "bdsPromoBadge";
    pallino.type = "button";
    pallino.textContent = "10%";
    pallino.setAttribute("aria-label", "Riapri lo sconto del 10%");

    var ics = document.createElement("button");
    ics.id = "bdsPromoBadgeX";
    ics.type = "button";
    ics.innerHTML = "&#10005;";
    ics.setAttribute("aria-label", "Nascondi lo sconto");

    document.body.appendChild(pallino);
    document.body.appendChild(ics);

    pallino.addEventListener("click", function () {
      via();
      if (typeof window.bdsOpenPromo === "function") window.bdsOpenPromo();
    });
    ics.addEventListener("click", function (e) {
      e.stopPropagation();
      segnaVisita(VIAPALLINO, "1");
      via();
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pallino.classList.add("bds-su");
        ics.classList.add("bds-su");
      });
    });
  }

  function via() {
    ["bdsPromoBadge", "bdsPromoBadgeX"].forEach(function (id) {
      var n = document.getElementById(id);
      if (!n) return;
      n.classList.remove("bds-su");
      setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 260);
    });
    pallino = null;
  }

  function forse() { if (siMostra()) costruisci(); }

  // 1 · chi aveva gia' chiuso in una visita precedente lo trova subito
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", forse);
  } else {
    forse();
  }

  // 2 · e chi lo chiude adesso lo vede comparire al posto del pop-up.
  //     L'evento lo manda la sezione, dentro closePromo.
  document.addEventListener("bds:promo-chiuso", function () {
    setTimeout(forse, 300);   // dopo la dissolvenza del pop-up, non sopra
  });

  // 3 · se si iscrive dal pop-up riaperto, il pallino sparisce e non torna
  document.addEventListener("bds:promo-iscritto", via);
})();
